import { SubsProduct } from 'models/SubsProduct';

export type SubsChannelProductsParams = Readonly<{
    items: SubsProduct[]
}>

export class SubsChannelProducts implements SubsChannelProductsParams {
    readonly items: SubsProduct[]

    constructor(params: SubsChannelProductsParams) {
        this.items = params.items
            .sort((a, b) => a.tier - b.tier)

        Object.freeze(this)
    }

    /**
     * 指定されたSubsProductsのtier以上のSubsProductsを取得する
     */
    permittedProducts(subsProductId?: string): SubsProduct[] {
        const subsProduct = subsProductId
            ? this.items.find((value) => value.id === subsProductId)
            : undefined
        if (!subsProduct) {
            // プラン未指定や存在しないプランが指定されていた場合は、どのプランでも利用可能
            return this.items
        }
        return this.items.filter((value) => (value.tier >= subsProduct.tier))
    }

    /**
     * 全てのidが等しいかチェックする
     */
    isEqualIds(subsProducts: SubsProduct[]): boolean {
        if (subsProducts.length !== this.items.length) {
            return false
        }
        var ids = new Set(this.items.map((item) => item.id))
        for(const i in subsProducts) {
            if(!ids.delete(subsProducts[i].id)) {
                return false
            }
        }
        return ids.size === 0
    }

    /**
     * tierが一番小さいものを取得する
     */
    get minTierProduct(): SubsProduct | null {
        if (this.items.length === 0) {
            return null
        }
        return this.items[0]
    }

    /**
     * tierが一番大きいものを取得する
     */
    get maxTierProduct(): SubsProduct | null {
        if (this.items.length === 0) {
            return null
        }
        return this.items[this.items.length - 1]
    }
}
